import React from 'react';
import styled from 'styled-components';
import { Text } from '@cko/primitives';
const StyledRowIcon = styled.div `
  margin: auto;
  width: 200px;
  min-width: 200px;

  svg {
    margin: auto;
    display: block;
  }
`;
const Description = styled(Text) `
  text-align: center;
  word-wrap: break-word;
  color: var(--base-text-secondary);
  margin: var(--layout-sandgrain) var(--layout-soybean);
`;
const RowIcon = ({ icon, description }) => {
    return (React.createElement(StyledRowIcon, null,
        icon,
        React.createElement(Description, null, description)));
};
export default RowIcon;
